import { render, staticRenderFns } from "./AssignTableModal.vue?vue&type=template&id=02e51619"
import script from "./AssignTableModal.vue?vue&type=script&lang=js"
export * from "./AssignTableModal.vue?vue&type=script&lang=js"
import style0 from "./AssignTableModal.vue?vue&type=style&index=0&id=02e51619&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports